import LinkOutlined from '@mui/icons-material/LinkOutlined';
import Button from '@mui/material/Button';
import { type ReactNode, useState } from 'react';

const COPIED_LABEL_MS = 1500;

export function CopyLinkButton({ url }: { url: string }): ReactNode {
  const [copied, setCopied] = useState(false);

  function handleCopy(): void {
    if (!navigator.clipboard) return;
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), COPIED_LABEL_MS);
      })
      .catch(() => {});
  }

  return (
    <Button
      variant="outlined"
      onClick={handleCopy}
      startIcon={<LinkOutlined sx={{ fontSize: 16, transform: 'rotate(-45deg)' }} />}
    >
      {copied ? 'Link copied' : 'Copy link'}
    </Button>
  );
}
